/*
 * Copyright Huesik (c) 2019.
 * 일반적인 Eventbus 파일입니다.
 */

import Vue from 'vue'

// 이벤트버스 생성
const EventBus = new Vue()

export default EventBus
